import React, { useState, useContext } from "react";
import { Popover, Select } from "antd";
import { AppContext } from "../../context";
import { truncate } from "../../library/text";
import SmallModal from "../../components/SmallModal/SmallModal";
import { EXPERIENCES } from "./experiencesConstants";
import ExperienceTable from "./components/ExperienceTable";
import MinimumNumberOfParticipants from "./components/MinimumNumberOfParticipants";

function ExperienceCardContent({ product, context }) {
  const [isPriceModalVisible, setIsPriceModalVisible] = useState(false);

  let info = useContext(AppContext);

  const popoverContent = (
    <div>
      <p>{product.request}</p>
    </div>
  );

  const selectComponent = () => {
    switch (context) {
      case undefined:
        return (
          <>
            <div className="card-body">
              <div className="short-description">
                {product.gen_description
                  ? truncate(product.gen_description[info.language], 100, true)
                  : ""}
              </div>
            </div>
            <MinimumNumberOfParticipants minNumber={product.exp_min_people} />
          </>
        );
      case "cart":
      case "reservation":
      case "ticket":
      case "payment":
        return (
          <ExperienceTable
            date={product.date}
            people={product.people}
            price={product.total_price}
            language={product.exp_language}
            request={product.request}
          />
        );

      case "reservation-info":
        return (
          <div>
            <div className="ahp-reservation-content">
              <div className="ahp-reservation-row">
                <div className="ahp-reservation-label">Data</div>
                <div className="ahp-reservation-value">
                  {context === "reservation-info"
                    ? info.experience.date.toISOString().split("T")[0]
                    : product.date}
                </div>
              </div>
              {/* <div className="ahp-reservation-row">
                <div className="ahp-reservation-label">Hora</div>
                <div className="ahp-reservation-value">{product.time}</div>
              </div> */}
              <div className="ahp-reservation-row">
                <div className="ahp-reservation-label">Pessoas</div>
                <div className="ahp-reservation-value">
                  {context === "reservation-info"
                    ? info.experience.people
                    : product.people}
                </div>
              </div>
              <div className="ahp-reservation-row">
                <div className="ahp-reservation-label">Preço</div>
                <div className="ahp-reservation-value">
                  {product.gen_price || product.total_price} €
                </div>
              </div>
              {context !== "reservation-info" && product.request && (
                <div className="ahp-reservation-notes">
                  <Popover
                    content={popoverContent}
                    title="Notas"
                    trigger="click"
                  >
                    <a role="button" tabindex="0">
                      {info.t("notes")}
                    </a>
                  </Popover>
                </div>
              )}
              <div style={{ marginTop: 10, display: "inline" }}>
                <strong>{info.t("preferredLanguageForActivity")}</strong>
              </div>
              <Select
                placeholder="LÍNGUA"
                options={EXPERIENCES.LANGUAGES_OPTS}
                value={info.experience?.language}
                onChange={(value) =>
                  info.setExperience({ ...info.experience, language: value })
                }
                bordered={false}
                style={{ marginTop: 10 }}
              />
            </div>
          </div>
        );
      default:
        return <div></div>;
    }
  };

  return (
    <>
      {context !== "ticket" &&
        context !== "reservation-info" &&
        context !== "payment" &&
        !(
          product.status === "not-available" || product.status === "not-defined"
        ) && (
          <div className="ahp-price">
            <div className="ahp-price-value">
              {product.gen_price || product.total_price} €
            </div>
            <div
              className="ahp-price-info"
              onClick={() => setIsPriceModalVisible(true)}
            >
              i
            </div>
          </div>
        )}
      {selectComponent()}
      <SmallModal
        text="Preço de toda a reserva, para o número de quartos e datas selecionadas."
        isPriceModalVisible={isPriceModalVisible}
        setIsPriceModalVisible={setIsPriceModalVisible}
      />
    </>
  );
}
export default ExperienceCardContent;
